/**
 * 新建回访记录
 */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Select, Row, Col, message, Input, DatePicker, Spin, ConfigProvider } from 'antd';
import _ from 'lodash';
import zhCN from 'antd/lib/locale/zh_CN';
import { get } from 'lodash-es';
import {SFuncModal} from "shj-components";
import {getUser} from "shj-utils";
import {iiHOC} from "@/utils/auth.ts";
import dayjs from "dayjs";
import {ticketsCallbackLog, ticketsDetail, ticketsGetLoginUserAttr} from "@/services/customerServices.ts";

const { Option } = Select;
const { TextArea } = Input;

export const ModalAddCallBackLogTab = (props: any) => <AddCallBackLogDom {...props} />;

export function addCallBackLogFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `新建回访记录`,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <AddCallBackLogDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const AddCallBackLogDom = (params: any) => {
  const { onClose, fn, id, issueId, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const { setFieldsValue } = form;
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  // const [dataLevel, setDataLevel] = useState<any>();

  // const [hasChargePerson, setHasChargePerson] = useState('');
  //
  // const [isDisposePerson, setIsDisposePerson] = useState<any>();
  // const [isChargePerson, setIsChargePerson] = useState<any>();
  // const [isCopyPerson, setIsCopyPerson] = useState<any>();
  // const [isCreatePerson, setIsCreatePerson] = useState<any>();
  const [currentStatus, setCurrentStatus] = useState<any>();

  useEffect(() => {
    // const user = getUser();
    // const group = get(user, 'currentRoles[0].dataLevel');
    // setDataLevel(group);
    initFn();
  }, []);

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const initFn = async () => {
    setSpinLoading(true);
    Promise.all([ticketsDetail(id), ticketsGetLoginUserAttr(id)])
      .then((resp) => {
        // setHasChargePerson(resp[0]?.orderList?.chargePerson);
        // setIsDisposePerson(resp[1]?.isDisposePerson);
        // setIsChargePerson(resp[1]?.isChargePerson);
        // setIsCopyPerson(resp[1]?.isCopyPerson);
        // setIsCreatePerson(resp[1]?.isCreatePerson);
        setCurrentStatus(resp[1]?.status);
        setSpinLoading(false);
      })
      .catch((err) => {
        setSpinLoading(false);
      });
  };
  const onFinish = () => {
    if (loading) return;
   form.validateFields().then(values => {
     setLoading(true);
     const _disposeContentReq = values;
     const _parameters = {
       callBackDate: _disposeContentReq.callBackDate
           ? dayjs(_disposeContentReq['callBackDate']).format('YYYY-MM-DD HH:mm:ss')
           : '',
       content: _disposeContentReq.content,
       result: _disposeContentReq.result,
       ticketsId: id,
       // ticketsId: issueId,
     };
     ticketsCallbackLog(_parameters).then(res=> {
       message.success(res.message || '操作成功')
       fn && fn();
       onClose();
     }) .finally(() => {
       setLoading(false);
     });
   })
  };
  return iiHOC(
    <SFuncModal.Content onCancel={onClose} onOk={onFinish} cancel={!formOnly}>
        <div>
          <Spin spinning={spinLoading} tip="加载中...">
      {(currentStatus == 3 || currentStatus == 5) ? ( // && dataLevel == 'dataLevelGroup'
            <Form
                layout={'vertical'}
              ref={formNode}
              form={form}
              onFinish={onFinish}
            >
              <Row gutter={2}>
                <Col span={24}>
                  <Form.Item label=" 回访结果" name="result" required rules={[{ required: true, message: '请选择' }]}>
                    <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                      <Option value="1">归档</Option>
                      <Option value="2">重新打开</Option>
                      <Option value="3">作废归档</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="回访时间"
                    name="callBackDate"
                    required
                    rules={[{ required: true, message: '请选择' }]}
                  >
                    <DatePicker
                      disabled={btnStatus(false)}
                      style={{ width: '100%' }}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="回访结果描述" name="content">
                    <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} maxLength={200} showCount />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
      ) : (
        // <div>请先在《工单详情》中填写“添加责任人</div>
        <div>当前状态或登录人不可操作</div>
      )}
          </Spin>
        </div>
    </SFuncModal.Content>,
  );
};
